<template>
  <f7-page
    ptr
    :ptr-mousewheel="true"
    @ptr:refresh="loadMore"
    ptr-content
    ptr-bottom
    no-shadow
    class="tamtam_page bg-surface font-body-md text-on-surface"
  >
    <f7-navbar sliding no-shadow back-link>
      <f7-nav-left> <navbarleft v-if="!isTablet"></navbarleft> </f7-nav-left>
      <f7-nav-title class="font-headline-sm font-bold text-primary">{{ $t("tamtam.tamtam") }}</f7-nav-title>
      <f7-nav-right>
        <f7-link
          v-if="isTablet"
          icon-aurora="f7:ellipses_bubble_fill"
          icon-ios="f7:ellipses_bubble_fill"
          icon-md="material:chat"
          @click="openSendMessageLeftPanel()"
        ></f7-link>
        <f7-link
          v-if="!isTablet"
          class="searchbar-enable"
          data-searchbar=".searchbar-ContactList"
          icon-aurora="f7:search_strong"
          icon-ios="f7:search_strong"
          icon-md="material:search"
        ></f7-link>
        <f7-link
          popover-open=".otherActions"
          icon-aurora="f7:ellipsis_vertical"
          icon-ios="f7:ellipsis_vertical"
          icon-md="material:more_vert"
        ></f7-link>
      </f7-nav-right>
      <f7-subnavbar
        :inner="false"
        no-shadow
        class="no-shadow"
        v-if="hasGroupList && isTablet"
      >
        <f7-searchbar
          :backdrop="false"
          search-container=".chatContact-list"
          :placeholder="$t('tamtam.searchConversationMessage')"
          search-in=".item-title, .item-after, .item-text, .item-footer"
          search-group-title=".list-group-title"
          :clear-button="true"
        ></f7-searchbar>
      </f7-subnavbar>
      <f7-searchbar
        v-if="!isTablet"
        class="searchbar-ContactList"
        expandable
        search-container=".chatContact-list"
        search-in=".item-title, .item-after, .item-text, .item-footer"
        search-group-title=".list-group-title"
        :clear-button="true"
        :backdrop="false"
      ></f7-searchbar>
    </f7-navbar>

    <div v-if="showJoinPrompt" class="px-gutter-mobile pt-2 pb-1">
      <div class="bg-surface-container-low rounded-xl p-3.5 shadow-sm border border-primary-container/10">
        <div class="display-flex align-items-center gap-3 mb-2">
          <div class="w-10 h-10 rounded-full bg-primary-fixed display-flex align-items-center justify-content-center text-primary flex-shrink-0 shadow-xs">
            <f7-icon material="chat" :size="20" />
          </div>
          <div class="min-w-0">
            <div class="font-label-lg font-bold text-on-surface truncate">
              <span v-html="$t('tamtam.joinAvochat')"></span>
            </div>
            <div class="font-body-sm text-outline truncate">{{ $t('tamtam.joinAvochatSubtitle') }}</div>
          </div>
        </div>
        <f7-list dividers-ios strong-ios media-list no-margin>
          <f7-list-item :title="$t('tamtam.discussWithOther')">
            <template #media>
              <f7-icon material="forum" :size="18" class="text-primary align-self-center" />
            </template>
          </f7-list-item>
          <f7-list-item :title="$t('tamtam.contactCustomersSellers')">
            <template #media>
              <f7-icon material="storefront" :size="18" class="text-primary align-self-center" />
            </template>
          </f7-list-item>
          <f7-list-item :title="$t('tamtam.sharePaymentAnd')">
            <template #media>
              <f7-icon material="save" :size="18" class="text-primary align-self-center" />
            </template>
          </f7-list-item>
          <f7-list-item :title="$t('tamtam.receiveAndRequestPayments')">
            <template #media>
              <f7-icon material="payments" :size="18" class="text-primary align-self-center" />
            </template>
          </f7-list-item>
        </f7-list>
      </div>
    </div>
    <f7-list dividers-ios strong-ios v-if="showSkeleton" media-list>
      <f7-list-item
        v-for="n in 10"
        :key="n"
        class="skeleton-text skeleton-effect-blink"
        :title="$t('tamtam.fullName')"
        subtitle="Position dolor"
        after=" 6 June 2020"
        ><template #media>
          <f7-skeleton-block
            style="width: 40px; height: 40px; border-radius: 50%"
          ></f7-skeleton-block>
        </template>
      </f7-list-item>
    </f7-list>
    <f7-list
      dividers-ios
      strong-ios
      class="searchbar-not-found"
      media-list
      v-else-if="showNoResults"
    >
      <f7-list-item
        :subtitle="$t('tamtam.noconversationmessageorcontactfound')"
      ></f7-list-item>
    </f7-list>
    <template v-if="hasGroupList">
    <f7-list
      dividers-ios
      strong-ios
      media-list
      no-chevron
      menu-list
      class="chatContact-list searchbar-found no-margin"
      v-for="chatGp in groupList"
      :key="chatGp.id"
    >
      <li v-if="chatGp.groupType === 'GROUP'">
        <ChatListItem
          :chatGroup="chatGp"
          :isActive="chatGp.id === group.id"
          :activeMessageList="messageList"
          :isPersonal="chatGp.groupType==='PERSONAL'"
          :selected="selected"
          @navigate="goTochatGp(chatGp)"
          @context-menu="groupDetailPopover"
        />
        <ul v-if="chatGp.subGroupList && chatGp.subGroupList.length > 0">
          <li
            v-for="(chatSubGroup, index) in chatGp.subGroupList"
            :key="index + '' + chatSubGroup.name"
          >
            <ChatListItem
              v-if="chatSubGroup.participant"
              :chatGroup="chatSubGroup"
              :isActive="chatSubGroup.id === group.id"
              :isPersonal="chatGp.groupType==='PERSONAL'"
              :activeMessageList="messageList"
              :selected="selected"
              :isSubGroup="true"
              @navigate="goTochatGp(chatSubGroup)"
              @context-menu="groupDetailPopover"
            />
          </li>
        </ul>
      </li>
      <li v-if="chatGp.groupType === 'PERSONAL' && getCounterpart(chatGp)">
        <ChatListItem
          :chatGroup="chatGp"
          :counterpart="getCounterpart(chatGp)"
          :isActive="chatGp.id === group.id"
          :isPersonal="chatGp.groupType==='PERSONAL'"
          :activeMessageList="messageList"
          :selected="selected"
          @navigate="goTochatGp(chatGp)"
          @context-menu="groupDetailPopover"
        />
      </li>
    </f7-list>
    </template>
    <sendMsgPanel></sendMsgPanel>
    <template #fixed>
      <f7-fab
        v-if="!isTablet && hasChat"
        position="right-bottom"
        @click="openSendMessageLeftPanel()"
      >
        <f7-icon
          ios="f7:ellipses_bubble_fill"
          aurora="f7:ellipses_bubble_fill"
          md="material:chat"
        ></f7-icon>
      </f7-fab>
    </template>
    <div class="ptr-preloader">
      <div class="preloader"></div>
      <div class="ptr-arrow"></div>
    </div>
    <f7-popover class="otherActions">
      <f7-list dividers-ios strong-ios media-list no-chevron no-margin>
        <f7-list-item
          link="#"
          popover-close
          :title="$t('tamtam.newGroup')"
          @click="openCreateGroupLeftPanel()"
        >
          <template #media>
            <f7-icon material="group_add" :size="18" class="text-primary align-self-center" />
          </template>
        </f7-list-item>
        <f7-list-item
          link="#"
          popover-close
          :title="$t('tamtam.newMessage')"
          @click="openSendMessageLeftPanel()"
        >
          <template #media>
            <f7-icon material="edit_square" :size="18" class="text-primary align-self-center" />
          </template>
        </f7-list-item>
      </f7-list>
    </f7-popover>
    <f7-fab
      v-if="showJoinPrompt"
      position="center-bottom"
      @click="joinAvochat()"
    >
      <f7-icon ios="f7:plus" aurora="f7:plus" md="material:add" />
      <template #text>
        <span v-html="$t('tamtam.joinAvochat')"></span>
      </template>
    </f7-fab>
  </f7-page>
</template>
<style scoped>
.actionsSheetTaphold {
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
.chip-delete {
  color: red !important;
}
.unReadBadge {
  position: absolute;
  right: 0px;
  border-radius: 25px;
  width: var(--f7-tabbar-icon-size);
  height: var(--f7-tabbar-icon-size);
}
.tamtam_page .chat-menu-icon {
  display: none;
}
.tamtam_page .item-subtitle {
  position: relative;
}
.tamtam_page .item-subtitle .text-container {
  overflow: hidden;
  white-space: nowrap;
  max-width: calc(100% - 25px);
  text-overflow: ellipsis;
  display: inline-block;
}
.tamtam_page .item-link:hover .item-subtitle .text-container {
  max-width: calc(100% - 40px);
}
.tamtam_page .item-link:hover .item-subtitle .unReadBadge {
  right: 20px;
}
.tamtam_page .item-link:hover .chat-menu-icon {
  display: inline-block;
  position: absolute;
  right: 0px;
  color: gray;
}
.item-link {
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
@media screen and (min-width: 768px) {
  a.link.icon-only.back {
    display: none;
  }
}
@media only screen and (min-width: 1024px) {
  .view-main {
    max-width: 100% !important;
  } /* .popup {        max-width: 768px !important;        margin: auto !important;    } */
} /* @media screen and (min-width: 1023px) {  .view-master-detail .page-master {    min-width: 60%;  }} */
</style>
<style>
.logoCropper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
@media only screen and (min-width: 769px) {
  .vue-advanced-cropper {
    max-height: 500px;
    position: relative;
    margin: 0 auto;
    max-width: 50%; /* width: 450px;  left: 20%; */
  }
  .vertical-buttons {
    position: absolute;
    right: 2.5%;
    top: 50%;
    transform: translateY(-50%);
  }
}
@media only screen and (max-width: 768px) {
  .vue-advanced-cropper {
    max-height: 500px;
    position: relative;
    margin: 0 auto;
    width: 100%;
  }
  .vertical-buttons {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.removeAttachement {
  position: absolute;
  right: 16px;
  top: 8px;
}
</style>
<script setup>
import { ref, computed, onMounted, getCurrentInstance } from "vue";
import { f7 } from "framework7-vue";
import { useMessageStore } from "../js/pinia-stores/message.js";
import { useLocationStore } from "../js/pinia-stores/location.js";
import { useAccountStore } from "../js/pinia-stores/account.js";
import { useKeycloakStore } from "../js/pinia-stores/keycloak.js";
import { useAuthStore } from "../js/pinia-stores/auth.js";
import { useTabletScreen } from "../js/composables/useMediaQuery.js";
import {
  useMessageOptions,
  useMessageGroup,
} from "../js/composables/useMessage.js";
import { useGroupCreation } from "../js/composables/useGroupCreation.js";
import { useAttachDocs } from "../js/composables/useAttachDocs.js";
import navbarleft from "../components/navbarleft.vue";
import sendMsgPanel from "../components/tamtam/sendMsgPanel.vue";
import ChatListItem from "../components/tamtam/ChatListItem.vue";
import { useWebSocket } from "../js/composables/useWebSocket.js";
import { useTransactAuth } from "../js/composables/useTransactAuth.js";
import i18n from "../js/i18n.js";
const props = defineProps({ f7route: Object, f7router: Object });
const isTablet = useTabletScreen().matches;
const profile = computed(() => useAuthStore().profile);
const userAccount = computed(() => useAccountStore().userAccount);
const country = computed(() => useLocationStore().country);
const chatUser = computed(() => useMessageStore().chatUser);
const groupList = computed(() => useMessageStore().groupList);
const counterPartUserList = computed(
  () => useMessageStore().counterPartUserList,
);
const msgCltConnected = computed(() => useMessageStore().msgCltConnected);
const messageSocketClient = computed(
  () => useMessageStore().messageSocketClient,
);
const keycloakStore = useKeycloakStore();
const selected = ref("");
const reactionEmoji = ref([]);
const selectedMessages = ref([]);
const messageIsSelected = ref(false);
const currentMessage = ref({});
const messageInScope = ref("");
const transferMsgRecipients = ref([]);
const reactionMessage = ref("");
const isOpenedReactionPopover = ref(false);
const messageList = computed(() => useMessageStore().messageList);
const group = computed(() => useMessageStore().group);
const { openGroupCreation } = useGroupCreation();
const { addSubgroup } = useMessageGroup({});
const { groupDetailPopover } = useMessageOptions({
  isTablet,
  profile,
  userAccount,
  messageSocketClient,
  reactionEmoji,
  selectedMessages,
  messageIsSelected,
  currentMessage,
  messageInScope,
  transferMsgRecipients,
  chatUser,
  groupList,
  group,
  messageList,
  reactionMessage,
  isOpenedReactionPopover,
  addSubgroup,
});
useAttachDocs({ isTablet });
const { connectMessageSocket } = useWebSocket({ f7router: props.f7router });
const messageStore = useMessageStore();
const { checkAuth } = useTransactAuth({ f7route: props.f7route, f7router: props.f7router });
 function navigateToGroup(chatGp) {
  const targetUrl = `/message/${chatGp.id}/${chatGp.groupType}`;
  const currentRoute = props.f7router?.currentRoute;

  if (
    currentRoute?.params &&
    currentRoute.params.id === chatGp.id &&
    currentRoute.params.type === chatGp.groupType
  ) {
    console.log("navigateToGroup already active, skipping", targetUrl);
    return;
  }
  messageStore.group = chatGp;
  console.log("navigateToGroup", chatGp);
  console.log("navigateToGroup messageList", messageStore.messagesData);
  f7.views.main.router
    .navigate(targetUrl, { reloadDetail: true ,transition: "f7-parallax" });

}
async function goTochatGp(chatGp) {
  let isProtected = false;
  // if (chatGp.protectedBy) {
    isProtected = chatGp.protectedBy.find(
      (x) => x === profile?.value?.sub
    )
     
  // } 
  if (!isProtected) {
    await navigateToGroup(chatGp);
    return;
  }
  await checkAuth({
    intent: { type: "navigate", route: `/message/${chatGp.id}/${chatGp.groupType}` },
    reason: i18n.global.t("tamtam.protectedGroupReason"),
    onSuccess: () => navigateToGroup(chatGp),
  });
}
function loadMore(done) {
  setTimeout(() => {
    useAccountStore().getAllUsers();
    if (chatUser.value) {
      useMessageStore().getUserGroups();
    }
    done();
  }, 1000);
}
function openSendMessageLeftPanel() {
  f7.panel.toggle(".sendMessageLeftPanel", true);
}
function openCreateGroupLeftPanel() {
  openGroupCreation();
}
function joinAvochat() {
  useMessageStore().joinMessaging();
}
function getCounterpart(grp) {
  if (grp.groupType !== "PERSONAL" || !grp.groupParticipantList) {
    return null;
  }
  return (
    grp.groupParticipantList.find((x) => x.userId !== profile?.value?.sub) || null
  );
}
const hasChat = computed(() => !!chatUser.value);
const hasGroupList = computed(
  () => !!groupList.value && groupList.value.length > 0,
);
const showJoinPrompt = computed(() => !chatUser.value || chatUser.value === "");
const showSkeleton = computed(() => hasChat.value && !groupList.value);
const showNoResults = computed(
  () => hasChat.value && !!groupList.value && groupList.value.length === 0,
);
onMounted(() => {
  f7.$(".view-main").css("width", f7.width);
  if (!msgCltConnected.value) {
    connectMessageSocket();
  }
  if (window._keycloak?.authenticated) {
    if (!chatUser.value) {
      useMessageStore().getChatUser();
    }
    setTimeout(() => {
      if (!groupList.value) {
        useMessageStore().getUserGroups();
      }
      if (!counterPartUserList.value) {
        useMessageStore().getCounterPartUserList();
      }
    }, 300);
  }
  if (!country.value) {
    useLocationStore().getCountry();
  }
  if (isTablet.value) {
    f7.$(".tamtam_page .page").addClass("page-with-subnavbar");
    f7.$(".tamtam_page .page-content").addClass("hide-bars-on-scroll");
  }
});
</script>
